import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ITag } from '../../../types/contactModule';
import { ContactsService } from '../../../services/contacts/contacts.service';
import { CsvServiceService } from '../../../services/csv/csv-service.service';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { GroupPickerComponent } from '../../organization/contacts/group-picker/group-picker.component';
import { formatCount } from '../../../../utils/sms';

/**
 * Tags rows of an import before they are saved (local only). The picker can
 * also create a tag on the spot when a search finds none.
 */
@Component({
  selector: 'csv-assign-multiple-contacts-to-tags',
  standalone: true,
  imports: [ModalFormContainerComponent, GroupPickerComponent],
  templateUrl: './csv-assign-multiple-contacts-to-tags.component.html',
  styleUrls: [
    '../../organization/contacts/group-picker/group-modal.css',
    './csv-assign-multiple-contacts-to-tags.component.css',
  ],
})
export class CsvAssignMultipleContactsToTagsComponent implements OnChanges {
  @Input({ required: true }) open: boolean = false;
  @Input() selectedContactsIndexes: (string | number)[] = [];
  @Input() selection: ITag[] = [];
  @Output() close = new EventEmitter();
  @Output() resetSelectedContactsIndexes = new EventEmitter();
  @Output() updateSelection = new EventEmitter<ITag[]>();

  // services
  contactService = inject(ContactsService);
  csvService = inject(CsvServiceService);
  private cdr = inject(ChangeDetectorRef);

  selectedTags: ITag[] = [];

  get rowLabel(): string {
    const count = this.selectedContactsIndexes?.length ?? 0;
    return count === 1 ? '1 row' : `${formatCount(count)} rows`;
  }

  get submitLabel(): string {
    const count = this.selectedTags.length;
    if (!count) return 'Choose tags';
    return count === 1 ? 'Add 1 tag' : `Add ${count} tags`;
  }

  onPick(items: any[]) {
    this.selectedTags = items as ITag[];
    this.updateSelection.emit(this.selectedTags);
    // Lives inside the OnPush review table.
    this.cdr.markForCheck();
  }

  handleSubmit() {
    if (!this.selectedTags.length) return;
    this.csvService.assignSelectedTagsToSelectedContacts(this.selectedContactsIndexes, this.selectedTags);
    this.resetSelectedContactsIndexes.emit();
    this.closeModal();
  }

  closeModal() {
    this.close.emit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['open'] || changes['selection']) {
      this.selectedTags = [...(this.selection ?? [])];
    }
  }
}
